export const faxFailureMessages = {
  INVALID_NUMBER: 'The fax number appears to be invalid.',
  RECIPIENT_UNAVAILABLE: "The recipient's fax line was busy or did not answer.",
  RECIPIENT_INCOMPATIBLE: 'Could not establish a compatible connection with the receiving fax machine.',
  TRANSMISSION_FAILED: 'The fax connection failed during transmission.',
  DOCUMENT_ISSUE: 'The document could not be processed for faxing.',
  ACCOUNT_CONFIG: 'Fax service is not configured correctly for this account.',
  PROVIDER_ERROR: 'The fax provider returned an error.',
  UNKNOWN: 'The fax failed, but the exact reason could not be determined.',
} as const

export const faxFailureNextSteps = {
  INVALID_NUMBER: 'Check the number and try again.',
  RECIPIENT_UNAVAILABLE: 'Try again later.',
  RECIPIENT_INCOMPATIBLE: 'Confirm the destination is a working fax machine; contact the recipient if it keeps failing.',
  TRANSMISSION_FAILED: 'Try again. If it keeps failing, confirm the number is an active fax line.',
  DOCUMENT_ISSUE: 'Upload a different file or check the document format.',
  ACCOUNT_CONFIG: 'Contact support or review account settings.',
  PROVIDER_ERROR: 'Retry or contact support if it continues.',
  UNKNOWN: 'Contact support.',
} as const

type FaxFailureType = keyof typeof faxFailureMessages

const faxFailureEntries = (Object.keys(faxFailureMessages) as FaxFailureType[]).map((type) => ({
  type,
  message: faxFailureMessages[type],
  nextStep: faxFailureNextSteps[type],
}))

export const getFaxFailureDetailsByMessage = (message?: string | null) => {
  if (!message) {
    return null
  }

  return (
    faxFailureEntries.find((entry) => entry.message === message) ||
    faxFailureEntries.find((entry) => entry.type === 'UNKNOWN') ||
    null
  )
}
